module.exports = __webpack_public_path__ + "static/2017-JoVE-979e82978dbd0b4e4d29e1987bfe1753.pdf";